const headerSearch = {
  init() {
    const search = document.querySelector(".top-header__search");

    if (search !== null) {
      search.onclick = function (e) {
        e.preventDefault();
        const form = document.querySelector(".top-header__search-form form");

        if (form.classList.contains("active")) {
          form.classList.remove("active");
        } else {
          form.classList.add("active");
        }
      };
    }

    const mobileSearch = document.querySelector(".main-header__search");

    if (mobileSearch !== null) {
      mobileSearch.onclick = function (e) {
        e.preventDefault();
        const form = document.querySelector(".main-header__search-form form");

        if (form.classList.contains("active")) {
          form.classList.remove("active");
        } else {
          form.classList.add("active");
        }
      };
    }
  },
};

export default headerSearch;
